// Models
import Model from './Model'

class Employee extends Model {
  get schema () {
    return [
      'authorities',
      'email',
      'name',
      'onboarder',
      'user'
    ]
  }
}

export default Employee
